/**********************************************************************************
* GENERATED FILE - This file is automatically managed by the MJ CodeGen tool, 
* 
* DO NOT MODIFY THIS FILE - any changes you make will be wiped out the next time the file is
* generated
* 
**********************************************************************************/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// MemberJunction Imports
import { BaseFormsModule } from '@memberjunction/ng-base-forms';
import { EntityViewerModule } from '@memberjunction/ng-entity-viewer';
import { LinkDirectivesModule } from '@memberjunction/ng-link-directives';

// Import Generated Components
import { ORCIDAddressFormComponent } from "./Entities/ORCIDAddress/orcidaddress.form.component";
import { CommonAguPersonFormComponent } from "./Entities/CommonAguPerson/commonaguperson.form.component";
import { FeedbackPlatformApplicationUserFormComponent } from "./Entities/FeedbackPlatformApplicationUser/feedbackplatformapplicationuser.form.component";
import { CoreSignalAwardFormComponent } from "./Entities/CoreSignalAward/coresignalaward.form.component";
import { CoreSignalCertificationFormComponent } from "./Entities/CoreSignalCertification/coresignalcertification.form.component";
import { FeedbackPlatformCommitteeMemberFormComponent } from "./Entities/FeedbackPlatformCommitteeMember/feedbackplatformcommitteemember.form.component";
import { FeedbackPlatformCommitteeSelectionItemFormComponent } from "./Entities/FeedbackPlatformCommitteeSelectionItem/feedbackplatformcommitteeselectionitem.form.component";
import { FeedbackPlatformCommitteeSelectionFormComponent } from "./Entities/FeedbackPlatformCommitteeSelection/feedbackplatformcommitteeselection.form.component";
import { MAPSConferenceRegistrationFormComponent } from "./Entities/MAPSConferenceRegistration/mapsconferenceregistration.form.component";
import { MAPSContactMessageEventFormComponent } from "./Entities/MAPSContactMessageEvent/mapscontactmessageevent.form.component";
import { MAPSContactMessageFormComponent } from "./Entities/MAPSContactMessage/mapscontactmessage.form.component";
import { RecommendationContentFormComponent } from "./Entities/RecommendationContent/recommendationcontent.form.component";
import { RecommendationContributorContentFormComponent } from "./Entities/RecommendationContributorContent/recommendationcontributorcontent.form.component";
import { RecommendationContributorFormComponent } from "./Entities/RecommendationContributor/recommendationcontributor.form.component";
import { FeedbackPlatformConversationMessageFormComponent } from "./Entities/FeedbackPlatformConversationMessage/feedbackplatformconversationmessage.form.component";
import { FeedbackPlatformConversation__FeedbackPlatformFormComponent } from "./Entities/FeedbackPlatformConversation__FeedbackPlatform/feedbackplatformconversation__feedbackplatform.form.component";
import { CoreSignalCourseFormComponent } from "./Entities/CoreSignalCourse/coresignalcourse.form.component";
import { ResearchCvParseFormComponent } from "./Entities/ResearchCvParse/researchcvparse.form.component";
import { ResearchCvTagFormComponent } from "./Entities/ResearchCvTag/researchcvtag.form.component";
import { ORCIDDistinctionFormComponent } from "./Entities/ORCIDDistinction/orciddistinction.form.component";
import { ORCIDEducationFormComponent } from "./Entities/ORCIDEducation/orcideducation.form.component";
import { CoreSignalEducation__CoreSignalFormComponent } from "./Entities/CoreSignalEducation__CoreSignal/coresignaleducation__coresignal.form.component";
import { ORCIDEmailFormComponent } from "./Entities/ORCIDEmail/orcidemail.form.component";
import { ORCIDEmploymentFormComponent } from "./Entities/ORCIDEmployment/orcidemployment.form.component";
import { CoreSignalExperienceFormComponent } from "./Entities/CoreSignalExperience/coresignalexperience.form.component";
import { MAPSExportLogFormComponent } from "./Entities/MAPSExportLog/mapsexportlog.form.component";
import { ORCIDExternalIdentifierFormComponent } from "./Entities/ORCIDExternalIdentifier/orcidexternalidentifier.form.component";
import { dboflyway_schema_historyFormComponent } from "./Entities/dboflyway_schema_history/dboflyway_schema_history.form.component";
import { ORCIDFundingExternalIDFormComponent } from "./Entities/ORCIDFundingExternalID/orcidfundingexternalid.form.component";
import { ORCIDFundingFormComponent } from "./Entities/ORCIDFunding/orcidfunding.form.component";
import { JobsIngestBatchFormComponent } from "./Entities/JobsIngestBatch/jobsingestbatch.form.component";
import { adminIngestionRunFormComponent } from "./Entities/adminIngestionRun/adminingestionrun.form.component";
import { adminIngestionTypeFormComponent } from "./Entities/adminIngestionType/adminingestiontype.form.component";
import { ORCIDInvitedPositionFormComponent } from "./Entities/ORCIDInvitedPosition/orcidinvitedposition.form.component";
import { JobsJobPostingSourceFormComponent } from "./Entities/JobsJobPostingSource/jobsjobpostingsource.form.component";
import { JobsJobPostingFormComponent } from "./Entities/JobsJobPosting/jobsjobposting.form.component";
import { ORCIDKeywordFormComponent } from "./Entities/ORCIDKeyword/orcidkeyword.form.component";
import { CoreSignalLanguageFormComponent } from "./Entities/CoreSignalLanguage/coresignallanguage.form.component";
import { ResearchMemberDocumentFormComponent } from "./Entities/ResearchMemberDocument/researchmemberdocument.form.component";
import { ResearchMemberItemStateFormComponent } from "./Entities/ResearchMemberItemState/researchmemberitemstate.form.component";
import { CoreSignalMemberOrganizationFormComponent } from "./Entities/CoreSignalMemberOrganization/coresignalmemberorganization.form.component";
import { ResearchMemberProfileFormComponent } from "./Entities/ResearchMemberProfile/researchmemberprofile.form.component";
import { ResearchMemberRecommendationFormComponent } from "./Entities/ResearchMemberRecommendation/researchmemberrecommendation.form.component";
import { ORCIDMembershipFormComponent } from "./Entities/ORCIDMembership/orcidmembership.form.component";
import { FeedbackPlatformNominationResponseFormComponent } from "./Entities/FeedbackPlatformNominationResponse/feedbackplatformnominationresponse.form.component";
import { FeedbackPlatformNominationFormComponent } from "./Entities/FeedbackPlatformNomination/feedbackplatformnomination.form.component";
import { FeedbackPlatformNotificationTypeFormComponent } from "./Entities/FeedbackPlatformNotificationType/feedbackplatformnotificationtype.form.component";
import { FeedbackPlatformNotificationFormComponent } from "./Entities/FeedbackPlatformNotification/feedbackplatformnotification.form.component";
import { ORCIDOtherNameFormComponent } from "./Entities/ORCIDOtherName/orcidothername.form.component";
import { FeedbackPlatformParticipantFormComponent } from "./Entities/FeedbackPlatformParticipant/feedbackplatformparticipant.form.component";
import { MAPSPartnerTokenUserFormComponent } from "./Entities/MAPSPartnerTokenUser/mapspartnertokenuser.form.component";
import { MAPSPartnerTokenFormComponent } from "./Entities/MAPSPartnerToken/mapspartnertoken.form.component";
import { CoreSignalPatentFormComponent } from "./Entities/CoreSignalPatent/coresignalpatent.form.component";
import { ORCIDPeerReviewFormComponent } from "./Entities/ORCIDPeerReview/orcidpeerreview.form.component";
import { MAPSPersonFormComponent } from "./Entities/MAPSPerson/mapsperson.form.component";
import { MAPSPersonHonorReceivedFormComponent } from "./Entities/MAPSPersonHonorReceived/mapspersonhonorreceived.form.component";
import { MAPSPersonJobFormComponent } from "./Entities/MAPSPersonJob/mapspersonjob.form.component";
import { MAPSPersonQualificationFactsFormComponent } from "./Entities/MAPSPersonQualificationFacts/mapspersonqualificationfacts.form.component";
import { MAPSPersonVolunteerActivityFormComponent } from "./Entities/MAPSPersonVolunteerActivity/mapspersonvolunteeractivity.form.component";
import { FeedbackPlatformPresentationCategoryFormComponent } from "./Entities/FeedbackPlatformPresentationCategory/feedbackplatformpresentationcategory.form.component";
import { FeedbackPlatformPresentationFormComponent } from "./Entities/FeedbackPlatformPresentation/feedbackplatformpresentation.form.component";
import { CoreSignalProfileMatchFormComponent } from "./Entities/CoreSignalProfileMatch/coresignalprofilematch.form.component";
import { CoreSignalProfileFormComponent } from "./Entities/CoreSignalProfile/coresignalprofile.form.component";
import { CoreSignalProjectFormComponent } from "./Entities/CoreSignalProject/coresignalproject.form.component";
import { CoreSignalPublicationFormComponent } from "./Entities/CoreSignalPublication/coresignalpublication.form.component";
import { ORCIDQualificationFormComponent } from "./Entities/ORCIDQualification/orcidqualification.form.component";
import { ORCIDRecordLinkFormComponent } from "./Entities/ORCIDRecordLink/orcidrecordlink.form.component";
import { ORCIDRecordFormComponent } from "./Entities/ORCIDRecord/orcidrecord.form.component";
import { ORCIDResearchResourceFormComponent } from "./Entities/ORCIDResearchResource/orcidresearchresource.form.component";
import { ORCIDResearcherUrlFormComponent } from "./Entities/ORCIDResearcherUrl/orcidresearcherurl.form.component";
import { FeedbackPlatformReviewAssignmentFormComponent } from "./Entities/FeedbackPlatformReviewAssignment/feedbackplatformreviewassignment.form.component";
import { FeedbackPlatformReviewQuestionRubricFormComponent } from "./Entities/FeedbackPlatformReviewQuestionRubric/feedbackplatformreviewquestionrubric.form.component";
import { FeedbackPlatformReviewQuestionTypeFormComponent } from "./Entities/FeedbackPlatformReviewQuestionType/feedbackplatformreviewquestiontype.form.component";
import { FeedbackPlatformReviewQuestionFormComponent } from "./Entities/FeedbackPlatformReviewQuestion/feedbackplatformreviewquestion.form.component";
import { FeedbackPlatformReviewResponseFormComponent } from "./Entities/FeedbackPlatformReviewResponse/feedbackplatformreviewresponse.form.component";
import { FeedbackPlatformReviewThankYouNoteFormComponent } from "./Entities/FeedbackPlatformReviewThankYouNote/feedbackplatformreviewthankyounote.form.component";
import { FeedbackPlatformReviewFormComponent } from "./Entities/FeedbackPlatformReview/feedbackplatformreview.form.component";
import { MAPSSearchLogFormComponent } from "./Entities/MAPSSearchLog/mapssearchlog.form.component";
import { FeedbackPlatformSeasonFormComponent } from "./Entities/FeedbackPlatformSeason/feedbackplatformseason.form.component";
import { FeedbackPlatformSectionFormComponent } from "./Entities/FeedbackPlatformSection/feedbackplatformsection.form.component";
import { ORCIDServiceFormComponent } from "./Entities/ORCIDService/orcidservice.form.component";
import { FeedbackPlatformSessionNominatorFormComponent } from "./Entities/FeedbackPlatformSessionNominator/feedbackplatformsessionnominator.form.component";
import { FeedbackPlatformSessionFormComponent } from "./Entities/FeedbackPlatformSession/feedbackplatformsession.form.component";
import { CoreSignalSkillFormComponent } from "./Entities/CoreSignalSkill/coresignalskill.form.component";
import { FeedbackPlatformSystemSettingFormComponent } from "./Entities/FeedbackPlatformSystemSetting/feedbackplatformsystemsetting.form.component";
import { MAPSUploadedDocumentFormComponent } from "./Entities/MAPSUploadedDocument/mapsuploadeddocument.form.component";
import { FeedbackPlatformUserNotificationSettingFormComponent } from "./Entities/FeedbackPlatformUserNotificationSetting/feedbackplatformusernotificationsetting.form.component";
import { ORCIDWorkExternalIDFormComponent } from "./Entities/ORCIDWorkExternalID/orcidworkexternalid.form.component";
import { ORCIDWorkFormComponent } from "./Entities/ORCIDWork/orcidwork.form.component";
   

@NgModule({
declarations: [
    ORCIDAddressFormComponent,
    CommonAguPersonFormComponent,
    FeedbackPlatformApplicationUserFormComponent,
    CoreSignalAwardFormComponent,
    CoreSignalCertificationFormComponent,
    FeedbackPlatformCommitteeMemberFormComponent,
    FeedbackPlatformCommitteeSelectionItemFormComponent,
    FeedbackPlatformCommitteeSelectionFormComponent,
    MAPSConferenceRegistrationFormComponent,
    MAPSContactMessageEventFormComponent,
    MAPSContactMessageFormComponent,
    RecommendationContentFormComponent,
    RecommendationContributorContentFormComponent,
    RecommendationContributorFormComponent,
    FeedbackPlatformConversationMessageFormComponent,
    FeedbackPlatformConversation__FeedbackPlatformFormComponent,
    CoreSignalCourseFormComponent,
    ResearchCvParseFormComponent,
    ResearchCvTagFormComponent,
    ORCIDDistinctionFormComponent],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_0 { }
    


@NgModule({
declarations: [
    ORCIDEducationFormComponent,
    CoreSignalEducation__CoreSignalFormComponent,
    ORCIDEmailFormComponent,
    ORCIDEmploymentFormComponent,
    CoreSignalExperienceFormComponent,
    MAPSExportLogFormComponent,
    ORCIDExternalIdentifierFormComponent,
    dboflyway_schema_historyFormComponent,
    ORCIDFundingExternalIDFormComponent,
    ORCIDFundingFormComponent,
    JobsIngestBatchFormComponent,
    adminIngestionRunFormComponent,
    adminIngestionTypeFormComponent,
    ORCIDInvitedPositionFormComponent,
    JobsJobPostingSourceFormComponent,
    JobsJobPostingFormComponent,
    ORCIDKeywordFormComponent,
    CoreSignalLanguageFormComponent,
    ResearchMemberDocumentFormComponent,
    ResearchMemberItemStateFormComponent],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_1 { }
    


@NgModule({
declarations: [
    CoreSignalMemberOrganizationFormComponent,
    ResearchMemberProfileFormComponent,
    ResearchMemberRecommendationFormComponent,
    ORCIDMembershipFormComponent,
    FeedbackPlatformNominationResponseFormComponent,
    FeedbackPlatformNominationFormComponent,
    FeedbackPlatformNotificationTypeFormComponent,
    FeedbackPlatformNotificationFormComponent,
    ORCIDOtherNameFormComponent,
    FeedbackPlatformParticipantFormComponent,
    MAPSPartnerTokenUserFormComponent,
    MAPSPartnerTokenFormComponent,
    CoreSignalPatentFormComponent,
    ORCIDPeerReviewFormComponent,
    MAPSPersonFormComponent,
    MAPSPersonHonorReceivedFormComponent,
    MAPSPersonJobFormComponent,
    MAPSPersonQualificationFactsFormComponent,
    MAPSPersonVolunteerActivityFormComponent,
    FeedbackPlatformPresentationCategoryFormComponent],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_2 { }
    


@NgModule({
declarations: [
    FeedbackPlatformPresentationFormComponent,
    CoreSignalProfileMatchFormComponent,
    CoreSignalProfileFormComponent,
    CoreSignalProjectFormComponent,
    CoreSignalPublicationFormComponent,
    ORCIDQualificationFormComponent,
    ORCIDRecordLinkFormComponent,
    ORCIDRecordFormComponent,
    ORCIDResearchResourceFormComponent,
    ORCIDResearcherUrlFormComponent,
    FeedbackPlatformReviewAssignmentFormComponent,
    FeedbackPlatformReviewQuestionRubricFormComponent,
    FeedbackPlatformReviewQuestionTypeFormComponent,
    FeedbackPlatformReviewQuestionFormComponent,
    FeedbackPlatformReviewResponseFormComponent,
    FeedbackPlatformReviewThankYouNoteFormComponent,
    FeedbackPlatformReviewFormComponent,
    MAPSSearchLogFormComponent,
    FeedbackPlatformSeasonFormComponent,
    FeedbackPlatformSectionFormComponent],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_3 { }
    


@NgModule({
declarations: [
    ORCIDServiceFormComponent,
    FeedbackPlatformSessionNominatorFormComponent,
    FeedbackPlatformSessionFormComponent,
    CoreSignalSkillFormComponent,
    FeedbackPlatformSystemSettingFormComponent,
    MAPSUploadedDocumentFormComponent,
    FeedbackPlatformUserNotificationSettingFormComponent,
    ORCIDWorkExternalIDFormComponent,
    ORCIDWorkFormComponent],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_4 { }
    


@NgModule({
declarations: [
],
imports: [
    GeneratedForms_SubModule_0,
    GeneratedForms_SubModule_1,
    GeneratedForms_SubModule_2,
    GeneratedForms_SubModule_3,
    GeneratedForms_SubModule_4
]
})
export class GeneratedFormsModule { }
    
// Note: LoadXXXGeneratedForms() functions have been removed. Tree-shaking prevention
// is now handled by the pre-built class registration manifest system.
// See packages/CodeGenLib/CLASS_MANIFEST_GUIDE.md for details.
    